<template>
  <div class="row" style="margin-bottom: 10px">
    <span class="page-title">Formulário de Perguntas</span>
  </div>
  <div class="row">
    <div class="col-2 selectElement">
      <div class="row">
        <h6 style="text-align: center; margin-top: 15px">Adicionar Campos</h6>
        <ul class="list-group selectListElement" id="list-group">
          <li class="list-group-item" @click="adicionarCampo('text')" v-bind:class="{ 'list-group-active': text }">
            <span>Campo Texto</span>
          </li>
          <li class="list-group-item" @click="adicionarCampo('textarea')" v-bind:class="{ 'list-group-active': textarea }"><span>Texto área</span></li>
          <li class="list-group-item" @click="adicionarCampo('select')" v-bind:class="{ 'list-group-active': select }"><span>Combo</span></li>
          <li class="list-group-item" @click="adicionarCampo('radio')" v-bind:class="{ 'list-group-active': radio }"><span>Radio Button</span></li>
          <li class="list-group-item" @click="adicionarCampo('checkbox')" v-bind:class="{ 'list-group-active': checkbox }"><span>Checkbox</span></li>
        </ul>
      </div>
    </div>
    <div class="col">
      <form v-if="fields.length > 0">
        <div class="question-form2">
          <label class="label-form">Nome do Formulário</label>

          <input class="form-control form-input-component" v-model="nomeForm" id="nomeForm" type="text" />
        </div>

        <h3 style="text-align: center">Perguntas Adicionada(s)</h3>

        <draggable :list="fields" @change="switchIds">
          <div class="question-form" v-for="(field, index) in fields" :key="field.id">
            <label :for="field.id" class="label-form">{{ index + 1 }}. {{ field.label }}<b style="color: red; font-size: 15px; margin-left: 5px" v-if="field.required">*</b></label>

            <input class="form-control form-input-component" v-if="field.type === 'text'" v-model="field.value" :id="field.id" :name="field.id" type="text" disabled />

            <textarea class="form-control form-input-component" v-if="field.type === 'textarea'" v-model="field.value" :id="field.id" :name="field.id" disabled></textarea>

            <select class="form-control form-input-component" v-if="field.type === 'select'" v-model="field.value" :id="field.id" :name="field.id">
              <option v-for="(option, optionIndex) in field.options" :key="optionIndex" :value="option.value" disabled>
                {{ option.label }}
              </option>
            </select>

            <div v-if="field.type === 'radio'">
              <div class="form-check" v-for="(option, optionIndex) in field.options" :key="optionIndex">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="{{option}}" disabled />
                <label class="form-check-label" for="flexRadioDefault1">
                  {{ option.label }}
                </label>
              </div>
            </div>

            <div v-if="field.type === 'checkbox'">
              <div class="form-check" v-for="(option, optionIndex) in field.options" :key="optionIndex">
                <input class="form-check-input" type="checkbox" value="{{option}}" id="flexCheckDefault" disabled />
                <label class="form-check-label" for="flexCheckDefault">
                  {{ option.label }}
                </label>
              </div>
            </div>

            <div class="col justify-content-end" style="margin: 5px 5px">
              <div class="float-end">
                <a @click="removerElementForm(field)"><i class="fas fa-trash icon-trash" style="margin-left: 5px"></i></a>
              </div>
            </div>
          </div>
        </draggable>
        <div class="container row">
          <div class="col justify-content-end" style="margin-top: 5px">
            <div class="float-end">
              <button type="button" class="btn btn-primary" @click="salvarForm">Salvar formulário</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-3 addElement" v-if="addElement">
      <div v-if="addElement.type === 'text' || addElement.type === 'textarea'">
        <h5 v-if="addElement.type === 'text'" style="text-align: center">Campo Texto</h5>
        <h5 v-if="addElement.type === 'textarea'" style="text-align: center">Campo Texto área</h5>
        <label>Nome Label</label>
        <input type="text" class="form-control form-input-component" v-model="label" id="nomeLabel" aria-describedby="nomeLabel" required />
      </div>

      <div v-if="addElement.type === 'select'">
        <h5 style="text-align: center">Combo</h5>
        <label>Label Combo</label>
        <input type="text" class="form-control form-input-component" v-model="label" id="labelCombo" aria-describedby="nomeLabel" required />

        <label>Item Combo</label>
        <input type="text" class="form-control form-input-component" v-model="labelCombo" id="comboName" aria-describedby="nomeLabel" required />

        <div class="row justify-content-end" style="margin-top: 20px">
          <div class="float-end">
            <a @click="adicionarItemNaCombo()"><i class="fas fa-add icon-add" style="margin-left: 5px"></i>Add item</a>
          </div>
        </div>

        <label>Preview da Combo</label>
        <select class="form-select">
          <option v-for="item in addElementCombo" :key="item">
            {{ item.label }}
          </option>
        </select>
      </div>

      <div v-if="addElement.type === 'radio'">
        <h5 style="text-align: center">Radio</h5>
        <label>Label Radio</label>
        <input type="text" class="form-control form-input-component" v-model="label" id="labelRadio" aria-describedby="labelRadio" required />

        <label>Item Radio</label>
        <input type="text" class="form-control form-input-component" v-model="labelCombo" id="itemRadio" aria-describedby="itemRadio" required />

        <div class="row justify-content-end" style="margin-top: 20px">
          <div class="float-end">
            <a @click="adicionarItemNaCombo()"><i class="fas fa-add icon-add" style="margin-left: 5px"></i>Add item</a>
          </div>
        </div>

        <label>Preview da Radio</label>
        <br />
        <strong>{{ this.label }}</strong>

        <div class="form-check" v-for="(field, index) in addElementCombo" :key="index">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
          <label class="form-check-label" for="flexRadioDefault1">
            {{ field.label }}
          </label>
        </div>
      </div>

      <div v-if="addElement.type === 'checkbox'">
        <h5 style="text-align: center">Checkbox</h5>
        <label>Label Checkbox</label>
        <input type="text" class="form-control form-input-component" v-model="label" id="labelcheckbox" aria-describedby="labelcheckbox" required />

        <label>Item Checkbox</label>
        <input type="text" class="form-control form-input-component" v-model="labelCombo" id="checkboxitem" aria-describedby="checkbox" required />

        <div class="row justify-content-end" style="margin-top: 20px">
          <div class="float-end">
            <a @click="adicionarItemNaCombo()"><i class="fas fa-add icon-add" style="margin-left: 5px"></i>Add item</a>
          </div>
        </div>

        <label>Preview do Checkbox</label>
        <br />
        <strong>{{ this.label }}</strong>

        <div class="form-check" v-for="(field, index) in addElementCombo" :key="index">
          <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault2" />
          <label class="form-check-label" for="flexCheckDefault">
            {{ field.label }}
          </label>
        </div>
      </div>

      <label>Campo obrigatório ?</label>

      <div class="form-check" style="font-size: 15px">
        <input class="form-check-input" @click="setRequired(true)" type="radio" name="flexRadioDefault" id="flexRadioDefault3" />
        <label class="form-check-label" for="flexRadioDefault3"> Sim </label>
      </div>

      <div class="form-check" style="font-size: 15px">
        <input class="form-check-input" type="radio" @click="setRequired(false)" name="flexRadioDefault" id="flexRadioDefault4" />
        <label class="form-check-label" for="flexRadioDefault4"> Não </label>
      </div>

      <div style="margin-top: 10px; margin-bottom: 10px">
        <button type="button" class="btn btn-primary" @click="adicionarElementForm" style="margin-right: 10px">Adicionar no Formulário</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDataUser } from '@/utils';
import { createFormBuilder, getFormBuilderById } from '@/components/service/formBuilderService';
import { openNotification, typesNotification } from '@/utils/notifications';
import { VueDraggableNext } from 'vue-draggable-next';

export default {
  name: 'FormBuilder',
  components: {
    draggable: VueDraggableNext,
  },
  data() {
    return {
      formBuilder: null,
      fields: [],
      addElementCombo: [],
      itensRadio: [],
      addElement: null,
      nomeForm: null,
      label: null,
      labelCombo: null,
      idIncrement: 0,
      obrigatoriedade: 0,
      text: false,
      textarea: false,
      select: false,
      radio: false,
      checkbox: false,
    };
  },
  async created() {
    if (this.$route.query.id) {
      this.idForm = this.$route.query.id;
      await this.recuperarForm();
    }
  },
  methods: {
    async recuperarForm() {
      await getFormBuilderById(this.idForm).then((form) => {
        this.fields = form.data.questoes;
        this.formBuilder = form.data;
        this.nomeForm = form.data.nomeForm;
      });
    },
    adicionarCampo(type) {
      this.addElement = null;

      if (type) {
        this.resetActive();
        this[String(type)] = true;
        this.idIncrement = this.idIncrement + 1;
        this.addElement = {
          id: this.idIncrement,
          type: type,
        };
      }
    },
    resetActive() {
      this.text = false;
      this.textarea = false;
      this.select = false;
      this.radio = false;
      this.checkbox = false;
    },
    adicionarElementForm() {
      if (this.addElement && this.addElement.type && this.label) {
        this.addElement.label = this.label;
        this.addElement.required = this.obrigatoriedade;
        this.fields.push(this.addElement);
        this.resetField();
        this.resetActive();
      }
    },
    removerElementForm(field) {
      this.fields.splice(this.fields.indexOf(this.fields.find((f) => f.id === field.id)), 1);
    },
    adicionarItemNaCombo() {
      let itemCombo = {
        label: this.labelCombo,
      };
      this.labelCombo = null;
      this.addElementCombo.push(itemCombo);
      this.addElement.options = this.addElementCombo;
    },
    setRequired(value) {
      this.obrigatoriedade = value;
    },
    async salvarForm() {
      await createFormBuilder(this.monterObjeto()).then((r) => {
        if (!this.idForm) {
          this.resetField();
          this.fields = [];
          this.nomeForm = null;
          openNotification(typesNotification.success, 'Formulário de perguntas salvo com sucesso.');
        } else {
          this.formBuilder = r.data;
          openNotification(typesNotification.success, 'Formulário de perguntas editado com sucesso.');
        }
      });
    },
    monterObjeto() {
      let formBuilder = {};
      let userData = getDataUser();
      if (this.idForm) {
        formBuilder.id = this.idForm;
        formBuilder.dataCriacao = this.formBuilder.dataCriacao;
      }
      formBuilder.nomeForm = this.nomeForm;
      formBuilder.questoes = this.fields;
      formBuilder.cpfUsuario = userData.cpf;
      formBuilder.nomeUsuario = userData.nome;

      return formBuilder;
    },
    resetField() {
      this.label = null;
      this.labelCombo = null;
      this.addElement = null;
      this.obrigatoriedade = null;
      this.addElementCombo = [];
    },
    switchIds(event) {
      let elementNovo = this.fields[event.moved.newIndex];
      let idNovo = elementNovo.id;
      let elementVelho = this.fields[event.moved.oldIndex];
      let idVelho = elementVelho.id;
      elementNovo.id = idVelho;
      elementVelho.id = idNovo;
    },
  },
};
</script>

<style scoped>
#uploadImg {
  display: none;
}

.question-form {
  background: white;
  padding: 26px;
  border-radius: 10px 10px;
  margin-bottom: 10px;
  transition: transform 0.1s;
}

.addElement {
  transform: translate(0.4%, 0.4%);
  border-color: #a5a5a5;
  box-shadow: 6px 7px 0 8px rgb(55 55 55 / 20%);
  background: white;
}

.selectElement {
  transform: translate(0.4%, 0.4%);
  border-color: #a5a5a5;
  box-shadow: 8px 7px 0 -3px rgb(55 55 55 / 20%);
  background: white;
}

.selectListElement {
  padding-left: 11px;
  padding-top: 18px;
}

.list-group-item {
  cursor: pointer;
  margin-bottom: 3px;
}

.list-group-item::after {
  content: '';
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #0087ca;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

.list-group-item:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.question-form2 {
  background: white;
  padding: 26px;
  border-radius: 10px 10px;
  margin-bottom: 10px;
}

.list-group-item:active {
  border-bottom: 2px solid #0087ca;
}

.list-group-active {
  border-style: solid;
  border-color: #0087ca;
  border-width: 0px 2px 2px 2px;
  border-radius: 8px;
  background-image: linear-gradient(#001529, #083765);
  color: white;
  box-shadow: 0 0 15px #001529;
}

.question-form:hover {
  transform: translate(0.4%, 0.4%);
  border-color: #a5a5a5;
  box-shadow: 8px 7px 0 -3px rgba(55, 55, 55, 0.2);
  cursor: move;
}

.label-form {
  margin-bottom: 25px;
  font-family: ROBOTO, serif;
  font-size: 23px;
}

.form-check {
  font-size: 18px;
}
</style>
